import React from 'react';
import { ISearchResultItem } from "../types/search-engine.types";


const SearchResultItem: React.FC<ISearchResultItem> = ({item, handleNavigation, isActive}) => {

    let IconElement, Icon;

    if (typeof item.icon === "string") {
        IconElement = <span className={'result-item__icon'}>{item.icon}</span>;
    } else {
        Icon = item.icon;
    }

    return (

        <div
            key={item.id}
            className={`search-result-item ${isActive ? 'active' : ''}`}
            onClick={() => handleNavigation(item.route)}
        >
                            <span className={'search-result-item__icon-wrapper'}>
                                  {Icon ? <Icon size={16} className={'search-result-item__icon'}/> : IconElement}
                            </span>

            <span className={'search-result-item__title'}>{item.title}</span>
        </div>
    )


}

export default SearchResultItem;
